import { createSelector } from 'reselect';
import { discountedPriceWithCodeSelector } from 'selectors/testTarget/offers/discountedPriceWithCode/discountedPriceWithCodeSelector';

const showSelector = createSelector(discountedPriceWithCodeSelector, discountedPriceWithCode => !!discountedPriceWithCode.show);

export { showSelector };
